import Image from "next/image";
import styles from "../../common/CopyRight/copyRight.module.scss";
import Srcset from "@/components/common/Srcset";
import { isMobile,isTablet } from "mobile-device-detect";

export default function PaymentLogos({ isFullBasket, paymentLogoSize,isInstallmentMsg }) {
  const paymentLogosLayerOne = [
    {
      alt: "visa",
      src: "images/Logo/Visa.svg",
      class: "visa",
    },
    {
      alt: "mastercard",
      src: "images/Logo/Mastercard_2019_logo.svg",
      class:"mastercard",
    },
    {
      alt: "american-express-logo",
      src: "images/Logo/AmericanExpress-svg.svg",
      class: "amex",
    },
    {
      alt: "apple-card",
      src: "images/Logo/Apple-card-light.svg",
      class: "apple"
    }
  ];
  const paymentLogosLayerTwo = [
    {
      alt: "google-pay",
      src: "images/Logo/Google_Pay_Logo.svg",
      class: "gpay"
    },
    // {
    //   alt: "amazon-pay",
    //   src: "images/Logo/Amazon_Pay_logo.svg",
    // },
    {
      alt: "shop-pay",
      src: "images/Logo/ShopPay - Color.svg",
      class: "shoppay"
    }
  ];
  const desktopLogoSize = { height: "25", width: "42" };
  const mobileLogoSize = { height: "38", width: "70" };
  if (isFullBasket) {
    return (
      <div className={styles.payment_wrapper}>
        <div className={`grid-xs-12 ${styles.layer_one}`}>
          {paymentLogosLayerOne.map((logo, index) => {
            return (
              <span key={index}>
                <Srcset
                  svgFile={true}
                  alt={logo.alt}
                  src={logo.src}
                  requirePath={true}
                  height={paymentLogoSize.height}
                  width={paymentLogoSize.width}
                  className={styles.image}
                  lazyLoad={true}
                />
              </span>
            );
          })}
        </div>
        <div className={`grid-xs-12 ${styles.layer_one}`}>
          {paymentLogosLayerTwo.map((logo, index) => {
            return (
              <span key={index}>
                <Srcset
                  svgFile={true}
                  alt={logo.alt}
                  src={logo.src}
                  requirePath={true}
                  height={paymentLogoSize.height}
                  width={paymentLogoSize.width}
                  className={styles.image}
                  lazyLoad={true}
                />
              </span>
            );
          })}
        </div>
      </div>
    );
  }
  else if (isInstallmentMsg) {
    const desktopSize = { height: "26", width: "46" };
    const mobileSize = { height: "33", width: "57" };
    return (
      <>
         {paymentLogosLayerOne
            .concat(paymentLogosLayerTwo)
            .map((logo, index) => {
              return (
                <span key={index}>
                  <Srcset
                    height={isMobile?mobileSize.height:desktopSize.height}
                    width={isMobile?mobileSize.width:desktopSize.width}
                    className={`payment-logo ${logo.class}`}
                    alt={logo.alt}
                    requirePath={true}
                    svgFile={true}
                    src={logo.src}
                    lazyLoad={true}
                />
                
                </span>
              );
            })}
      </>
    )
  }
  else {
    return (
      <>
        <div
          className={`grid-md-6 grid-sm-6 d-xs-none text-md-end ${styles.payment_wrapper_desktop}`}
        >
          {paymentLogosLayerOne
            .concat(paymentLogosLayerTwo)
            .map((logo, index) => {
              return (
                <span key={index}>
                  <Srcset
                    height={desktopLogoSize.height}
                    width={desktopLogoSize.width}
                    className={styles.image}
                    alt={logo.alt}
                    requirePath={true}
                    svgFile={true}
                    src={logo.src}
                    lazyLoad={true}
                  />
                </span>
              );
            })}
        </div>
        <div className={styles.payment_wrapper}>
          <div className={`grid-xs-12 d-md-none ${styles.layer_one}`}>
            {paymentLogosLayerOne.map((logo, index) => {
              return (
                <span key={index}>
                  <Srcset
                    svgFile={true}
                    requirePath={true}
                    height={mobileLogoSize.height}
                    width={mobileLogoSize.width}
                    className={styles.image}
                    alt={logo.alt}
                    src={logo.src}
                    lazyLoad={true}
                  />
                </span>
              );
            })}
          </div>
          <div className={`grid-xs-12 d-md-none ${styles.layer_one}`}>
            {paymentLogosLayerTwo.map((logo, index) => {
              return (
                <span key={index}>
                  <Srcset
                    height={mobileLogoSize.height}
                    width={mobileLogoSize.width}
                    className={styles.image}
                    alt={logo.alt}
                    requirePath={true}
                    svgFile={true}
                    src={logo.src}
                    lazyLoad={true}
                  />
                </span>
              );
            })}
          </div>
        </div>
      </>
    );
  }
}